import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { asyncGetSurveyResponse } from '../../../../../services/survey.service';

export const useSurveyResponseDetail = () => {
    const { id } = useParams();
    const [response, setResponse] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            loadResponse();
        }
    }, [id]);

    const loadResponse = async () => {
        setLoading(true);
        try {
            const data = await asyncGetSurveyResponse(id!);
            setResponse(data);
        } catch (error) {
            console.error('Error loading survey response:', error);
        } finally {
            setLoading(false);
        }
    };

    return {
        response,
        loading,
    };
};
